<template>
  <div class="fp">
    <v-btn-toggle
      :value="value.scope"
      mandatory
      class="fp-toggle"
      @change="setScope"
    >
      <v-btn value="all" depressed>
        Все филиалы
      </v-btn>
      <v-btn value="filials" depressed>
        Выбранные
      </v-btn>
    </v-btn-toggle>

    <template v-if="value.scope === 'filials'">
      <div v-if="selected.length" class="fp-chips">
        <v-chip
          v-for="f in selected"
          :key="f.id"
          small
          close
          class="fp-chip"
          @click:close="toggle(f.id)"
        >
          {{ f.address || f.name }}
        </v-chip>
      </div>
      <div v-else class="fp-empty">
        Добавьте филиалы плюсом в списке
      </div>

      <v-text-field
        v-model="search"
        class="fp-search"
        placeholder="Поиск филиала"
        prepend-inner-icon="mdi-magnify"
        outlined
        dense
        hide-details
        clearable
      />
      <div class="fp-list">
        <div
          v-for="f in filtered"
          :key="f.id"
          class="fp-row"
          :class="{ on: isSelected(f.id) }"
          @click="toggle(f.id)"
        >
          <global-filial-select-item :item="f" is-list-item class="fp-item" />
          <v-btn
            icon
            small
            :color="isSelected(f.id) ? 'primary' : undefined"
            :title="isSelected(f.id) ? 'Убрать' : 'Добавить'"
            @click.stop="toggle(f.id)"
          >
            <v-icon small>
              {{ isSelected(f.id) ? 'mdi-check' : 'mdi-plus' }}
            </v-icon>
          </v-btn>
        </div>
        <div v-if="!filtered.length" class="fp-empty">
          Ничего не найдено
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import GlobalFilialSelectItem from '@/components/header/GlobalFilialSelectItem'

  /**
   * Охват импорта/экспорта зон: все филиалы или выбранные (плюсом в списке).
   * v-model: { scope: 'all' | 'filials', filialIds: number[] }
   */
  export default {
    name: 'FilialsPicker',
    components: { GlobalFilialSelectItem },
    props: {
      value: { type: Object, default: () => ({ scope: 'all', filialIds: [] }) },
      filials: { type: Array, default: () => [] },
    },
    data: () => ({ search: '' }),
    computed: {
      selected () {
        return this.value.filialIds
          .map((id) => this.filials.find((f) => f.id === id))
          .filter(Boolean)
      },
      filtered () {
        const q = (this.search || '').trim().toLowerCase()
        if (!q) return this.filials
        return this.filials.filter((f) =>
          [f.name, f.address, f.city].some((s) => (s || '').toLowerCase().includes(q)),
        )
      },
    },
    methods: {
      isSelected (id) {
        return this.value.filialIds.includes(id)
      },
      setScope (scope) {
        this.$emit('input', { ...this.value, scope })
      },
      toggle (id) {
        const ids = this.isSelected(id)
          ? this.value.filialIds.filter((x) => x !== id)
          : [...this.value.filialIds, id]
        this.$emit('input', { ...this.value, filialIds: ids })
      },
    },
  }
</script>

<style scoped>
.fp-toggle {
  width: 100%;
  border-radius: 10px !important;
}
.fp-toggle ::v-deep .v-btn {
  flex: 1;
  height: 40px !important;
  font-size: 14px;
  text-transform: none;
  letter-spacing: 0;
  background: #fff !important;
}
.fp-toggle ::v-deep .v-btn.v-btn--active {
  color: #ff9100 !important;
  background: rgba(255, 145, 1, 0.1) !important;
}
.fp-toggle ::v-deep .v-btn.v-btn--active::before {
  opacity: 0 !important;
}
.fp-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}
.fp-empty {
  margin-top: 12px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.5);
}
.fp-search {
  margin-top: 12px;
}
.fp-search ::v-deep fieldset {
  border-radius: 8px;
}
.fp-search ::v-deep input {
  font-size: 14px;
}
.fp-list {
  margin-top: 8px;
  max-height: 240px;
  overflow-y: auto;
  border: 1px solid #e0e3e7;
  border-radius: 8px;
}
.fp-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  cursor: pointer;
}
.fp-row:hover {
  background: #f5f5f5;
}
.fp-row.on {
  background: rgba(255, 145, 1, 0.08);
}
.fp-item {
  flex: 1;
  min-width: 0;
}
</style>
